function computeStepFromDuration(duration: string): string {
	switch (duration) {
		case 'PT1H30M':
		case 'PT2H':
		case 'PT3H':
		case 'PT4H':
		case 'PT5H':
			return 'PT1H';
		case 'PT45M':
			return 'PT15M';
		default:
			return duration;
	}
}

/**
 * Get the link to the booking page.
 * @param fullSlug - username:slug
 */
function getLink(fullSlug: string): string {
	// const [username, slug] = fullSlug.split(':');
	// return `${window.location.protocol}//${document.location.host}/b/${username}/${slug}`;

	return `${window.location.protocol}//${document.location.host}/book/${fullSlug}`;
}

/**
 * Get the static link to the booking page.
 * @param id - The ID of te event type
 */
function getIdLink(id: string): string {
	return `${window.location.protocol}//${document.location.host}/b/${id}`;
}

export default { computeStepFromDuration, getLink, getIdLink };
